import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Box, 
  CircularProgress,  
  Container,  
  Skeleton,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import useCurrencyService from '../../../../../components/hooks/useCurrencyService';
import useSelectedCompany from '../../../../../components/hooks/useSelectedCompany';
import DateFormatter from '../../../../../components/utils/DateFormatter';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import { 
  GetCompanyInternationalBlnkWalletBalanceBIZcore,
  GetCompanyInternationalBlnkWalletTransactionsBIZcore,
  InitBlnkWalletsBIZcore
} from '../../../../../redux/actions/business/core/companyBlnkWalletActions';

import InternationalBlnkWalletModal from './InternationalBlnkWalletModal';

const InternationalBlnkWalletPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core"]);
  const { handleShowAmount } = useCurrencyService();
  const companyId = useSelectedCompany();
  const [loading, setLoading] = useState(true);
  const [loadingActivity, setLoadingActivity] = useState(true);
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [blnkModalOpen, setBlnkModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [update, setUpdate] = useState(null);

  const [wallet, setWallet] = useState(null);

  const [activitiesList, setActivitiesList] = useState([]);
  const [activitiesTotal, setActivitiesTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Reference",
      sort: null,
    },
    {
      label: "Description",
      sort: null,
    },
    {
      label: "Created",
      sort: null,
    },
    {
      label: "Settlement",
      sort: null,
    },
    // {
    //   label: "Action",
    //   sort: null,
    // },
    {
      label: "Status",
      sort: null,
    },
    {
      label: "Amount",
      sort: null,
      align: "right"
    },
    {
      label: "Balance",
      sort: null,
      align: "right"
    }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetBalance();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetActivitiesList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);


  useEffect(() => {
    try {
      console.log(state.internationalBlnkWalletBalance)
      setWallet(state.internationalBlnkWalletBalance || null);

      formatActivitiesList(state.internationalBlnkWalletTransactionsList?.transactions || []);
      setActivitiesTotal(state.internationalBlnkWalletTransactionsList?.total_count || 0);
    } catch (err) {}  
  }, [state]);


  async function handleGetBalance(customLoading){
    dispatch(GetCompanyInternationalBlnkWalletBalanceBIZcore(companyId, customLoading ? customLoading : setLoading));
  };  

  async function handleGetActivitiesList(customLoading){
    dispatch(GetCompanyInternationalBlnkWalletTransactionsBIZcore(companyId, page+1, rowsPerPage, customLoading ? customLoading : setLoadingActivity))
  };

  const formatActivitiesList = (list) => {
    setActivitiesList(list)
  };

  const handleInitializeBlnkWallets = async () => {
    await dispatch(InitBlnkWalletsBIZcore(companyId, setLoadingActivity)).then(() => {
      handleGetBalance(setLoadingActivity).then(() => {
        handleGetActivitiesList(setLoadingActivity);
      });
    });
  };

  function handleStatuslabel(status){
    switch(status){
      case "APPLIED": return "Completed";
      case "INFLIGHT": return "Pending";
      case "QUEUED": return "Queued";
      case "VOID": return "Failed";
      case "REJECTED": return "Failed";

      default: return "";
    }
  };

  return (
    <Box>

      <InternationalBlnkWalletModal
        open={blnkModalOpen}
        setOpen={setBlnkModalOpen}
        title={modalTitle}
        update={update}
        handleGet={async () => {
          handleGetBalance();
          handleGetActivitiesList();
        }}
        />

      <TopBar
        title={"International Blnk Wallet"}
        button1Text={"Wallet Recharge"}
        button1OnClick={() => {
          setModalTitle("Wallet Recharge");
          setUpdate({ defaultMode: 1 });
          setBlnkModalOpen(true);
        }}
        button2Text={"Commit Transaction"}
        button2OnClick={() => {
          setModalTitle("Commit Transaction");
          setUpdate({ defaultMode: 2 });
          setBlnkModalOpen(true);
        }}
        button3Text={"Void Transaction"}
        button3OnClick={() => {
          setModalTitle("Void Transaction");
          setUpdate({ defaultMode: 3 });
          setBlnkModalOpen(true);
        }}
        button4Text={"Init Blnk Wallets"}
        button4OnClick={() => {
          handleInitializeBlnkWallets();
        }}
        />

      <Container
        maxWidth="md">
        <Box
          className="flexCenterCenterRow block"
          gap={"50px"}
          padding={"20px"}
          mt={"40px"}
          mb={"20px"}>
          {/* Available balance */}
          <Box
            className="flex__Column"
            gap={"20px"}>
            <Typography
              variant='subtitle2'
              color="grey"
              textAlign={"center"}>
              Available balance
            </Typography>
            {
              loading
              ?
              <Skeleton 
                variant="rectangular" 
                sx={{
                  borderRadius: "16px",
                  minWidth: "170px",
                  width: "50%",
                  height: "64.5px",
                  margin: "auto",
                }}
                  />
              :
                wallet
                ?
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "10px" }}>
                  <Typography
                    variant='h3'>
                    {handleShowAmount(wallet?.main_balance?.currency, wallet?.main_balance?.available_balance)}
                  </Typography>

                </Box>
                :
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "20px" }}>
                  <NA
                    label={"No wallet found"}/>
                </Box>
            }
          </Box>
          {/* Total balance */}
          <Box
            className="flex__Column"
            gap={"20px"}>
            <Typography
              variant='subtitle2'
              color="grey"
              textAlign={"center"}>
              Total balance
            </Typography>
            {
              loading
              ?
              <Skeleton 
                variant="rectangular" 
                sx={{
                  borderRadius: "16px",
                  minWidth: "170px",
                  width: "50%",
                  height: "64.5px",
                  margin: "auto",
                }}
                  />
              :
                wallet
                ?
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "10px" }}>
                  <Typography
                    variant='h3'>
                    {handleShowAmount(wallet?.main_balance?.currency, wallet?.main_balance?.balance)}
                  </Typography>

                </Box>
                :
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "20px" }}>
                  <NA
                    label={"No wallet found"}/>
                </Box>
            }
          </Box>
          {/* Fee balance */}
          <Box
            className="flex__Column"
            gap={"20px"}>
            <Typography
              variant='subtitle2'
              color="grey"
              textAlign={"center"}>
              Allocated balance
            </Typography>
            {
              loading
              ?
              <Skeleton 
                variant="rectangular" 
                sx={{
                  borderRadius: "16px",
                  minWidth: "170px",
                  width: "50%",
                  height: "64.5px",
                  margin: "auto",
                }}
                  />
              :
                wallet
                ?
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "10px" }}>
                  <Typography
                    variant='h3'>
                    {handleShowAmount(wallet?.allocated_balance?.currency, wallet?.allocated_balance?.balance)}
                  </Typography>

                </Box>
                :
                <Box
                  className="flexCenterCenterRow"
                  sx={{ padding: "20px" }}>
                  <NA
                    label={"No wallet found"}/>
                </Box>
            }
          </Box>
        </Box>

      </Container>

      
      <Container 
        maxWidth="lg">
        <Box
          className="flexCenterCenterColumn"
          gap={"20px"}
          mt={"40px"}
          mb={"20px"}>
          <Typography
            variant='subtitle2'
            color="grey"
            mb={"20px"}>
            Activity
          </Typography>
          {
            loadingActivity
            ?
            <CircularProgress />
            :
              <Table className="block">
                <TableHead>
                  <TableRow>
                    { 
                      tableHeadingsList.map((heading, headingIndex) => (
                        heading.sort === null
                        ?
                        <TableCell
                          key={headingIndex} 
                          align={heading.align || "left"}>{heading.label}</TableCell>
                        :
                        <TableCell
                          key={headingIndex}
                          align={heading.align || "left"}>
                          <TableSortLabel
                            active={sort === heading.sort ? true : false}
                            direction={sortDirection}
                            onClick={() => {
                              handleSort(heading.sort);
                            }}
                          >
                            {heading.label}
                          </TableSortLabel>
                        </TableCell>
                      ))
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    activitiesList.length === 0
                    ?
                    <Typography>
                      No activity found
                    </Typography>
                    :
                    activitiesList.map((row, index) => (
                      <TableRow 
                        key={index}>
                        <TableCell>
                          <Typography
                            className='longText'
                            variant='caption'
                            maxWidth={"350px"}>
                            <Copyable>
                              {row.reference || ""}
                            </Copyable>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {row.description || <NA />}
                        </TableCell>
                        <TableCell>
                          {row.created_at ? DateFormatter(row.created_at) : <NA />}
                        </TableCell>
                        <TableCell>
                          {row?.status === "APPLIED" && row.updated_at && row.updated_at !== row.created_at
                            ? DateFormatter(row.updated_at) 
                            : ""}
                        </TableCell>
                        <TableCell>
                          {handleStatuslabel(row.status) || <NA />}
                        </TableCell>
                        <TableCell
                          align='right'>
                          <Box
                            className="flexCenterFERow"
                            gap={"3px"}>
                            <Typography 
                              color={(row.meta_data?.destination_wallet_type === "INT_MAIN")
                                ? "green" 
                                : "red"}>
                              {(row.meta_data?.destination_wallet_type === "INT_MAIN")
                                ? "+" 
                                : "-" }
                            </Typography>
                            <span 
                              style={{ 
                                color: (row.meta_data?.destination_wallet_type === "INT_MAIN") 
                                  ? "green" 
                                  : "red",
                                margin: "0px", 
                                padding: "0px" 
                              }}>
                              {handleShowAmount(row?.currency, row?.amount)}
                            </span>
                          </Box>
                        </TableCell>
                        <TableCell
                          align='right'>
                          { (row?.status === "APPLIED")
                          ? handleShowAmount(row?.currency, row?.meta_data?.balance_fields?.balance_before)
                          : ""}
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      sx={{ borderBottom: 0 }}
                      rowsPerPageOptions={[5, 10, 25]} 
                      colSpan={10}
                      count={activitiesTotal}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'rows per page'
                        },
                        native: true
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                      />
                  </TableRow>
                </TableFooter>
              </Table>
          }
        </Box>
      </Container>
    </Box>
  )
}

export default InternationalBlnkWalletPage;